<div class="ltms-history-panel">
    <div class="ltms-history-header">
        <div>
            Latest updates are at the top. Scroll down for full history and use search and sorting
        </div>
        <div>
            <div class="litmus-history-filter" #litmusfeedhistorysearch id="litmusfeedhistorysearch">
                <div class="litmus-history-filter-input" [class.active]="showFilterFields">
                    <img class="search-icon" src="assets/images/magnify.svg">
                    <input type="text" (keyup)="filterHistory($event)" (click)="showFilterFields = false" [(ngModel)]="searchText" [placeholder]="placeholder" />
                    <button *ngIf="searchText != ''" (click)="clearSearch()">
                        <img class="clear-img" src="assets/images/close.svg">
                    </button>
                    <button class="dropdown-icon" (click)="toggleFilterFieldList()"> 
                        <img src="assets/images/menu-down-dark.svg" />
                    </button>
                </div>
                <ul id="litmus-search-selector" *ngIf="showFilterFields" class="litmus-feed-filter-list">
                    <li *ngFor="let item of fieldList" (click)="changeFilterField(item)"
                        [class.active]=" item.field == selectedFilter.field">
                        {{item.text}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="ltms-history-body" *ngIf="isHistoryLoaded">
        <div class="ltms-history-table-container">
            <app-ltms-data-table-v2 [columns]="columns"  [data]="data" [errorCode]="errorCode"></app-ltms-data-table-v2>
        </div>
    </div>
    <div class="history-loader" *ngIf="!isHistoryLoaded">
        <app-ltms-loader></app-ltms-loader>
    </div>
</div>